export default __webpack_public_path__ + "static/newsletter-bg-3b6b4c6533be58efab2ded8225879dda.svg";